import React, { useMemo } from "react";
import { useTranslate } from "@refinedev/core";
import { ChatSummaryStats } from "types/";
import { AnalyticsBarChart, type BarDatasetConfig } from "./AnalyticsBarChart";
import { analyticsTheme } from "./analyticsTheme";
import { getPercentageAxis, getCategoryAxis } from "./utils/";

const T_PREFIX = "media.projects.analytics.aiChatbot.sentimentDistribution";

export interface SentimentDistributionChartProps {
  data: ChatSummaryStats | null | undefined;
  loading: boolean;
}

export const SentimentDistributionChart: React.FC<
  SentimentDistributionChartProps
> = ({ data, loading }) => {
  const t = useTranslate();
  const chartOptions = useMemo(
    () => ({
      scales: { y: getPercentageAxis(), x: getCategoryAxis() },
    }),
    []
  );

  const labels = useMemo(
    () => [
      t(`${T_PREFIX}.positive`),
      t(`${T_PREFIX}.negative`),
      t(`${T_PREFIX}.unclear`),
    ],
    [t]
  );

  const datasets = useMemo<BarDatasetConfig[]>(
    () => [
      {
        label: t(`${T_PREFIX}.pct`),
        data: [
          Math.round(data?.positive_pct ?? 0),
          Math.round(data?.negative_pct ?? 0),
          Math.round(data?.unclear_pct ?? 0),
        ],
        color: analyticsTheme.datasetEmerald,
      },
    ],
    [data, t]
  );

  return (
    <AnalyticsBarChart
      title={t(`${T_PREFIX}.title`)}
      labels={labels}
      datasets={datasets}
      loading={loading}
      direction="vertical"
      height={200}
      chartOptions={chartOptions}
    />
  );
};
